import React from 'react'

function Lifestyle() {
  return (
    <div>Lifestyle</div>
  )
}

export default Lifestyle